import { GDFPalletCode } from '../gdf/type';
import { Palette } from './palettes';

export const satellite: Palette[] = [
    {
        name: 'Satellite (visible)',
        id: GDFPalletCode.satellite,
        type: 'gradientBar',
        units: 'ft',
        suffix: 'k',
        minValue: 0,
        maxValue: 256,
        minDisplayValue: 6,
        maxDisplayValue: 60,
        tooltipSingleValue: true,
        stops: [
            { value: 0, color: '#000000' },
            { value: 6, color: '#a7a7a7' },
            { value: 14, color: '#dfdfdf' },
            { value: 22, color: '#ffffff' },
            { value: 23, color: '#ffffff', hideLabel: true },
            { value: 24, color: '#8c68a5' },
            { value: 30, color: '#7f4a90' },
            { value: 34, color: '#71337a' },
            { value: 36, color: '#ac772b' },
            { value: 40, color: '#c25917' },
            { value: 46, color: '#cc411e' },
            { value: 50, color: '#cc311b' },
            { value: 55, color: '#cd2a17' },
            { value: 59, color: '#cd2a18' }
        ],
        getValue: (x) => x + 1
    },
    {
        name: 'Satellite (IR)',
        id: GDFPalletCode.satir_256,
        type: 'gradientBar',
        units: 'ft',
        suffix: 'k',
        minValue: 0,
        maxValue: 127.5,
        maxDisplayValue: 70,
        stops: [
            { value: 5, color: '#747474' },
            { value: 10, color: '#8f8f8f' },
            { value: 15, color: '#adadad' },
            { value: 20, color: '#cdb4b6' },
            { value: 25, color: '#ff0000' },
            { value: 30, color: '#ff8000' },
            { value: 35, color: '#e6e600' },
            { value: 40, color: '#07d200' },
            { value: 45, color: '#33dcdc' },
            { value: 50, color: '#0101dc' },
            { value: 55, color: '#780078' },
            { value: 60, color: '#d20dd2' },
            { value: 65, color: '#fe85ff' },
            { value: 70, color: '#ffe4ff' }
        ],
        getValue: (x) => x * 0.5
    },
    {
        name: 'Satellite (IR) Temperature',
        id: GDFPalletCode.satir_256t,
        type: 'gradientBar',
        tooltipSingleValue: true,
        units: '°C',
        minValue: 30,
        maxValue: -90,
        stops: [
            { value: 30, color: '#000000' },
            { value: 20, color: '#2c2c2c' },
            { value: 10, color: '#414141' },
            { value: 0, color: '#565656' },
            { value: -10, color: '#6b6b6b' },
            { value: -20, color: '#818181' },
            { value: -29, color: '#959595', hideLabel: true },
            { value: -30, color: '#71ffdc' },
            { value: -31, color: '#6ae6fe', hideLabel: true },
            { value: -40, color: '#4dd0ff' },
            { value: -50, color: '#28adff' },
            { value: -60, color: '#1428d6' },
            { value: -70, color: '#6e0e83' },
            { value: -80, color: '#700c6e' },
            { value: -90, color: '#700c6e' }
        ],
        getValue: (x) => Math.floor(30.0 - (120.0 / 255.0) * x)
    },
    {
        name: 'Satellite Gray',
        id: GDFPalletCode.satvis_256f,
        type: 'gradientBar',
        minValue: 0,
        maxValue: 1,
        hideFromLegend: true,
        noTooltip: true,
        stops: [
            { value: 0, color: '#1a1a1a' },
            { value: 1 / 256, color: '#1a1a1a' },
            { value: 1, color: '#ffffff' }
        ]
    },
    {
        name: 'Satellite Gray',
        id: GDFPalletCode.satwv_256f,
        type: 'discreteBar',
        hideFromLegend: true,
        noTooltip: true,
        // prettier-ignore
        colors:["#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#ff0000","#fe1e00","#fd3d00","#fc5c00","#fc7b00","#fb9a00","#fab900","#f9d800","#f9f700","#f3ef00","#ede800","#e7e000","#e2d800","#dcd100","#d6c900","#d0c100","#caba00","#c5b200","#bfaa00","#b9a300","#b39b00","#ad9300","#a88c00","#a28400","#9c7c01","#967501","#916d01","#8b6501","#855e01","#7f5601","#794e01","#744701","#6e3f01","#683701","#623001","#5c2801","#572001","#511901","#4b1101","#450901","#400202","#320303","#240505","#160707","#090909","#0e0e0e","#141414","#1a1a1a","#1f1f1f","#252525","#2b2b2b","#313131","#363636","#3c3c3c","#424242","#474747","#4d4d4d","#535353","#595959","#5e5e5e","#646464","#6a6a6a","#6f6f6f","#757575","#7b7b7b","#818181","#868686","#8c8c8c","#929292","#989898","#9d9d9d","#a3a3a3","#a9a9a9","#aeaeae","#b4b4b4","#bababa","#c0c0c0","#c5c5c5","#cbcbcb","#d1d1d1","#d6d6d6","#dcdcdc","#e2e2e2","#e8e8e8","#ededed","#f3f3f3","#f9f9f9","#ffffff","#e0e0f0","#c1c1e2","#a3a3d4","#8484c6","#6565b8","#4747aa","#28289c","#0a0a8e","#091995","#08289c","#0837a3","#0747aa","#0656b1","#0665b8","#0575bf","#0584c6","#0493cd","#03a3d4","#03b2db","#02c1e2","#01d1e9","#01e0f0","#00eff7","#00ffff","#0fffef","#1fffdf","#2fffcf","#3fffbf","#4fffaf","#5fff9f","#6fff8f","#7fff7f","#8fff6f","#9fff5f","#afff4f","#bfff3f","#cfff2f","#dfff1f","#efff0f","#ffff00","#fcef00","#f9df00","#f6cf00","#f4bf00","#f1af00","#ee9f00","#ec8f00","#e97f00","#e66f00","#e45f00","#e14f00","#de3f00","#dc2f00","#d91f00","#d60f00","#d40001","#cc0000","#c40000","#bc0000","#b40000","#ac0000","#a40000","#9c0000","#950000","#980007","#9b000f","#9e0017","#a2001f","#a50027","#a8002f","#ac0037","#af003f","#b20047","#b6004f","#b90057","#bc005f","#c00067","#c3006f","#c60077","#ca007f","#cd0087","#d0008f","#d30097","#d6009f","#da00a7","#dd00af","#e000b7","#e400bf","#e700c7","#ea00cf","#ee00d7","#f100df","#f400e7","#f800ef","#fb00f7","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#ff00ff","#fe0b00","#fe0800","#fe0500","#fe0200","#ff0000","#ff0000"],
        values: []
    },
    {
        id: GDFPalletCode.satir_256n,
        name: 'Satellite (altitude-based)',
        type: 'gradientBar',
        tooltipSingleValue: true,
        minValue: 750,
        maxValue: 55000,
        stops: [
            { value: 750, color: '#000000' },
            { value: 5000, color: '#404040' },
            { value: 10000, color: '#575757' },
            { value: 15000, color: '#6f6f6f' },
            { value: 20000, color: '#868686' },
            { value: 23000, color: '#959595', hideLabel: true },
            { value: 23500, color: '#6ee8ff', hideLabel: true },
            { value: 25000, color: '#61dfff' },
            { value: 30000, color: '#3abdff' },
            { value: 35000, color: '#167ff7' },
            { value: 40000, color: '#5111a5' },
            { value: 45000, color: '#970d98' },
            { value: 50000, color: '#ff10bb' },
            { value: 55000, color: '#ff0000' }
        ],
        units: 'ft',

        getValue: (nIndex) => {
            let nAltValue = Math.floor(1000 + (nIndex - 1) * (54000.0 / 254.0));
            // Round to nearest 250 ft
            const nAltT1 = Math.trunc(nAltValue / 1000);
            const nAltT2 = nAltValue % 1000;
            nAltValue = nAltT1 * 1000;
            if (nAltT2 >= 875) nAltValue += 1000;
            else if (nAltT2 >= 625) nAltValue += 750;
            else if (nAltT2 >= 375) nAltValue += 500;
            else if (nAltT2 > 125) nAltValue += 250;
            return nAltValue;
        }
    }
];
